import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/core/components/ui/card";
import { TrendingUp, MapPin, Target, AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { INSIGHTS_CLASSES, INSIGHTS_TITLES } from "../consts/configs";
import { buildInsightMessage } from "../utils/buildInsightMessage";
import { ReportViewerInsightsListProps } from "../types";

const ICONS: Record<string, JSX.Element> = {
  identified_growth: <TrendingUp className="h-4 w-4 text-green-600" />,
  geographic_expansion: <MapPin className="h-4 w-4 text-blue-600" />,
  improvement_opportunity: <Target className="h-4 w-4 text-orange-600" />,
  type_preference: <AlertCircle className="h-4 w-4 text-purple-600" />,
  default: <AlertCircle className="h-4 w-4 text-gray-600" />,
};

export function ReportViewerInsightsList({
  insights,
}: ReportViewerInsightsListProps) {
  const [translate] = useTranslation(["insights"]);
  return (
    <Card className="border-secondary">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-complementary-500">🔍</span>
          {translate("report-viewer-insights-list-title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {insights.map((insight, i) => {
            const icon = ICONS[insight.type] ?? ICONS.default;
            const klass =
              INSIGHTS_CLASSES[insight.type] ?? INSIGHTS_CLASSES.default;
            const title =
              INSIGHTS_TITLES[insight.type] ?? INSIGHTS_TITLES.default;
            return (
              <div key={i} className={`border-l-4 p-4 rounded-r-lg ${klass}`}>
                <div className="flex items-center gap-2 mb-2">
                  {icon}
                  <h4 className="font-medium">{translate(title)}</h4>
                </div>
                <p className="text-sm text-gray-700">
                  {buildInsightMessage(insight as any, translate)}
                </p>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
